import { Brand } from "../../components/Brand";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ApiError } from "../../lib/api";
import { Button, Field } from "../../components/ui";
import { register } from "./api";

export function RegisterPage() {
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await register({ email: email.trim(), password, fullName: fullName.trim() || undefined });
      setDone(true);
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : err instanceof Error
            ? err.message
            : "Échec de l'inscription",
      );
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="login-shell">
        <div className="login-card">
          <Brand className="login-brand" />
          <h1>Compte créé</h1>
          <p className="hint">
            Vérifiez votre boîte mail pour confirmer votre adresse, puis connectez-vous.
          </p>
          <Button onClick={() => navigate("/login", { replace: true })}>
            Aller à la connexion
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <Brand className="login-brand" />
        <h1>Créer un compte</h1>
        <Field
          label="Nom complet"
          autoComplete="name"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
        />
        <Field
          label="Email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Field
          label="Mot de passe"
          type="password"
          autoComplete="new-password"
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className="error-text">{error}</p>}
        <Button type="submit" disabled={busy}>
          {busy ? "Création…" : "Créer mon compte"}
        </Button>
        <nav className="auth-links">
          <Link to="/login">J'ai déjà un compte</Link>
        </nav>
      </form>
    </div>
  );
}
